import type { AssetTypeEntity } from "@/entities/asset-type";

import { useGetEntityTemplate } from "@/entities/entity-template";

export const useGetAssetTypeTemplate = (assetType?: AssetTypeEntity) => {
  return useGetEntityTemplate(assetType?.entity_template_id);
};
